import React, { useState } from 'react'
import PropTypes from 'prop-types'
import st from './OpenHeader.module.scss'
import { ReactComponent as Plus } from 'components/UI/icons/add-line.svg'
import { GoToLink } from 'components/UI/SuperButton/SuperButton'
import { ReactComponent as Arrow } from 'components/UI/icons/applications/arrow.svg'

const OpenHeader = (props) => {
  const [isClicked, setIsClicked] = useState(false)

  const handleClick = () => {
    setIsClicked((prev) => !prev)
    if (props.onClick) props.onClick()
  }

  return (
    <div className={st.header}>
      <h3 onClick={handleClick}>{props.title}</h3>
      <div className={st.buttons}>
        {props.addButton && (
          <div className={st.addButton} onClick={props.addButton}>
            <Plus />
          </div>
        )}
        {props.link && (
          <div>
            <GoToLink to={props.link} target={props.target} />
          </div>
        )}
        {props.openIcon && (
          <div className={st.arrowButton} onClick={handleClick}>
            <Arrow
              className={`${st.arrow} ${isClicked ? st.arrowRotated : ''}`}
            />
          </div>
        )}
      </div>
    </div>
  )
}

OpenHeader.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  addButton: PropTypes.func,
  openIcon: PropTypes.bool,
}

export default OpenHeader
